module.exports = __webpack_public_path__ + "static/kids-8dd033a27c5e1b13d4857652e7147201.svg";